'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdDevicesOther = function MdDevicesOther(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35 30v-13.4h-6.6v13.4h6.6z m1.6-16.6c0.9 0 1.8 0.7 1.8 1.6v16.6c0 0.9-0.9 1.8-1.8 1.8h-10c-0.8 0-1.6-0.9-1.6-1.8v-16.6c0-0.9 0.8-1.6 1.6-1.6h10z m-18.2 15.7c1.4 0 2.5-1.1 2.5-2.5s-1.1-2.5-2.5-2.5-2.5 1.1-2.5 2.5 1.1 2.5 2.5 2.5z m3.2-9.1v3c1.1 0.9 1.8 2.2 1.8 3.6s-0.7 2.9-1.8 3.8v3h-6.6v-3c-1-0.9-1.6-2.3-1.6-3.8s0.6-2.7 1.6-3.6v-3h6.6z m-16.6-10v20h6.6v3.4h-6.6c-1.8 0-3.4-1.6-3.4-3.4v-20c0-1.8 1.6-3.4 3.4-3.4h30v3.4h-30z' })
        )
    );
};

exports.default = MdDevicesOther;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/devices-other.js
// module id = 1369
// module chunks = 168707334958949